import { CreditDebitReconciliation } from "./credit-debit-reconciliation";

export function CreditReconciliation() {
  return <CreditDebitReconciliation transactionIndicator="CREDIT" />;
}
